// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__29f48","title":"BackImages_title__2a_5x","images":"BackImages_images__1DZ-U"};